import { FormattedMessage } from "react-intl";

export function ErrorMessageWithSupportLink({ id, defaultMessage }: { id: string, defaultMessage: string }) {
	return (<FormattedMessage id={id} defaultMessage={defaultMessage}
		values={{
			supportLink: (<a className="underline" href="https://www.midtown.com/contact-us/"><FormattedMessage id="app.error.support.link.text" defaultMessage="here" /></a>)
		}} />)
}